/**
 * Party failures, turned into sentences an operator can act on.
 *
 * Re-authored per feature rather than shared (the quotes/work/crfs precedent —
 * `crfs/errors.ts` records the reasoning): this module's refusals are about
 * CUSTOMERS, and a shared helper would grow a branch per feature until nobody
 * could tell which sentence any surface produces.
 *
 * Rules the siblings keep, kept here: a 403 never names the permission key (a
 * key is a word for administrators; the reader needs to know who to ask), and
 * 400/409/422 are PASSED THROUGH — the API's own wording names the rule it
 * found (`referral must be shorter than or equal to 200 characters`), and
 * replacing it would lose the one detail that says what to do next.
 */

import { ApiRequestError, ApiTransportError } from '../../lib/api';

export function partyErrorText(error: unknown): string {
  if (error instanceof ApiTransportError) {
    return 'The server could not be reached. Nothing was changed.';
  }
  if (error instanceof ApiRequestError) {
    if (error.code === 'COUNTRY_SCOPE_VIOLATION') {
      return 'That customer belongs to another country.';
    }
    if (error.status === 404) return 'That customer does not exist.';
    if (error.status === 403) {
      return 'This account is not allowed to do that in this country.';
    }
    return error.message;
  }
  return 'Something went wrong. Nothing was changed.';
}
